<mat-accordion>
  <mat-expansion-panel
    [expanded]="expandState"
    (afterCollapse)="collapsed.emit()"
    (afterExpand)="expanded.emit()"
  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon class="mr-2">apps</mat-icon>
        <span class="expansion-panel-title" translate>{{ panelTitle }}</span>
      </mat-panel-title>
      <mat-panel-description translate>
        {{ panelDescription }}
      </mat-panel-description>
    </mat-expansion-panel-header>
    <ng-content></ng-content>
  </mat-expansion-panel>
</mat-accordion>
